import { render, staticRenderFns } from "./MailValidation.vue?vue&type=template&id=31963d6b&"
import script from "./MailValidation.vue?vue&type=script&lang=js&"
export * from "./MailValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports